// auth.js — Global auth utility
// Import aur use karo kisi bhi file mein:
// import auth from '../Utilities/auth';

const AUTH_KEY = "user";

const auth = {
  // ----- Save -----
  save(data) {
    localStorage.setItem(AUTH_KEY, JSON.stringify(data));
  },

  // ----- Remove -----
  clear() {
    localStorage.removeItem(AUTH_KEY);
  },

  // ----- Raw stored object -----
  get() {
    try {
      return JSON.parse(localStorage.getItem(AUTH_KEY));
    } catch {
      return null;
    }
  },

  // ----- Tokens -----
  getAccessToken() {
    return this.get()?.accessToken || null;
  },
  getRefreshToken() {
    return this.get()?.refreshToken || null;
  },

  // ----- User info (from API response data) -----
  getUser() {
    const data = this.get();
    // Support both new format (userData) and old format (user)
    return data?.userData || data?.user || null;
  },
  getEmail() {
    return this.getUser()?.email || null;
  },
  getName() {
    return this.getUser()?.name || null;
  },
  getAdminId() {
    return this.getUser()?.user_id ?? null;
  },
  getRole() {
    return this.getUser()?.user_role ?? null;
  },
  isSuperAdmin() {
    return this.getUser()?.user_role === "SuperAdmin";
  },
  // Check if the current user has canView for a given pathname
  canViewRoute(pathname) {
    if (this.isSuperAdmin()) return true;
    const perms = this.getPermissions();
    const all = [];
    perms.forEach((p) => {
      if (p.menuUrl) all.push(p);
      (p.subMenus || []).forEach((s) => { if (s.menuUrl) all.push(s); });
    });
    return all.some(
      (p) => p.canView && pathname.startsWith(`/${p.menuUrl}`)
    );
  },
  // Returns {canView, canCreate, canEdit, canDelete} for a given pathname
  // Superadmin always gets full access
  getRoutePerms(pathname) {
    if (this.isSuperAdmin()) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    const perms = this.getPermissions();
    const all = [];
    perms.forEach((p) => {
      if (p.menuUrl) all.push(p);
      (p.subMenus || []).forEach((s) => { if (s.menuUrl) all.push(s); });
    });
    const match = all.find((p) => pathname.startsWith(`/${p.menuUrl}`));
    if (!match) return { canView: false, canCreate: false, canEdit: false, canDelete: false };
    return {
      canView: !!match.canView,
      canCreate: !!match.canCreate,
      canEdit: !!match.canEdit,
      canDelete: !!match.canDelete,
    };
  },
  getProfileImage() {
    return this.getUser()?.profile_image || null;
  },
  isLocked() {
    return this.getUser()?.is_lock === "Y";
  },
  isActive() {
    return this.getUser()?.user_status === true;
  },

  // ----- Permissions (menu links from login response) -----
  getPermissions() {
    return this.get()?.permissions || [];
  },

  // ----- Check login -----
  isLoggedIn() {
    return !!this.getAccessToken();
  },
};

export default auth;
